<template>
  <b-container fluid class="content clover-page">
    <b-row class="mt-4"><b-col>
      <b-card no-body><b-card-body>
        <div class="clover-heading"><h2>Clover</h2><span>StoreID: {{ StoreID }}</span></div>
        <b-alert :show="!!message" :variant="messageType" role="status">{{ message }}</b-alert>
        <b-form @submit.prevent="save(false)">
          <b-form-group label="App Id (client_id)" label-for="clover-app-id"><b-form-input id="clover-app-id" v-model.trim="form.app_id" maxlength="32" required :disabled="busy" /></b-form-group>
          <b-form-group label="OAuth Env." label-for="clover-mode"><b-form-select id="clover-mode" v-model="form.mode" :options="modes" :disabled="busy" /></b-form-group>
          <b-form-group label="RAID (X-POS-id/Remote App)" label-for="clover-raid"><b-form-input id="clover-raid" v-model.trim="form.raid" :disabled="busy" /></b-form-group>
          <b-form-group label="App Secret" label-for="clover-secret" :description="hasSecret ? 'A secret is saved. Leave blank to keep it, or enter a replacement.' : ''"><b-form-input id="clover-secret" v-model="form.app_secret" type="password" maxlength="64" autocomplete="new-password" :disabled="busy" /></b-form-group>
          <b-form-group label="Merchant Id (optional)" label-for="clover-merchant"><b-form-input id="clover-merchant" v-model.trim="form.merchant_id" maxlength="32" :disabled="busy" /></b-form-group>
          <div class="clover-actions">
            <el-button :disabled="busy" @click="$router.push('/store')">{{ $t('Back') }}</el-button>
            <el-button type="primary" native-type="submit" :loading="busy && action === 'save'" :disabled="busy || !ready">Save</el-button>
            <el-button type="success" :loading="busy && action === 'send'" :disabled="busy || !ready" @click="save(true)">Send</el-button>
          </div>
        </b-form>
        <dl v-if="saved" class="clover-status"><dt>Status</dt><dd>{{ statusLabel }}</dd><dt>Auth Store ID</dt><dd>{{ saved.auth_store_id || '—' }}</dd><dt>Access Token Expiration</dt><dd>{{ tokenDate(saved.access_token_expiration) }}</dd></dl>
      </b-card-body></b-card>
    </b-col></b-row>
  </b-container>
</template>
<script>
import { Button } from 'element-ui';
import axios from 'axios';
import { getStore } from '../../util/helper';

export default {
  components: { [Button.name]: Button },
  data() {
    return {
      StoreID: '', busy: false, action: '', message: '', messageType: 'info', hasSecret: false, saved: null,
      form: { app_id: '', mode: 0, raid: '', app_secret: '', merchant_id: '' },
      modes: [
        { value: 0, text: 'Sandbox' }, { value: 1, text: 'ProductionNorthAmerica' },
        { value: 2, text: 'ProductionEurope' }, { value: 3, text: 'ProductionLatinAmerica' }
      ]
    };
  },
  computed: {
    ready() { return !!this.StoreID && !!this.form.app_id; },
    statusLabel() { return ['Saved locally', 'Sent — awaiting Clover authorization', 'Token received'][Number(this.saved.Status)] || 'Saved locally'; }
  },
  watch: { '$route.query.StoreID'() { this.init(); } },
  mounted() { this.init(); },
  methods: {
    async call(action, values = {}) {
      const data = new FormData();
      data.append('token', getStore('token'));
      data.append('user_id', getStore('user_id'));
      data.append('StoreID', this.StoreID);
      Object.keys(values).forEach(key => data.append(key, values[key]));
      const response = await axios.post(`/Api/Web/Clover${action ? '/' + action : ''}`, data);
      if (response.data.status !== 0) throw new Error(response.data.message || 'Request failed');
      return response.data.data;
    },
    apply(store) {
      this.saved = store && store.StoreID ? store : null;
      this.hasSecret = !!(this.saved && this.saved.has_app_secret);
      this.form = {
        app_id: (store && store.app_id) || '', mode: store && store.mode !== undefined ? Number(store.mode) : 0,
        raid: (store && store.raid) || '', app_secret: '', merchant_id: (store && store.merchant_id) || ''
      };
    },
    async init() {
      if (!getStore('token') || !getStore('user_id')) { this.$router.push('/login'); return; }
      const name = (getStore('username') || '').toLowerCase();
      if (!['pkadmin', 'posking'].includes(name)) { this.message = 'No Permission'; this.messageType = 'danger'; return; }
      this.StoreID = this.$route.query.StoreID || '';
      if (!this.StoreID) { this.message = 'Select a store from the Store page first.'; this.messageType = 'warning'; return; }
      this.busy = true; this.message = '';
      try { this.apply((await this.call('')).store); }
      catch (e) { this.message = e.response ? 'Unable to load Clover settings.' : e.message; this.messageType = 'danger'; }
      finally { this.busy = false; }
    },
    async save(send) {
      if (this.busy || !this.ready) return;
      if (send && !this.form.app_secret && !this.hasSecret) { this.message = 'App Secret is required before Send.'; this.messageType = 'danger'; return; }
      this.busy = true; this.action = send ? 'send' : 'save'; this.message = '';
      try {
        const result = await this.call(this.action, this.form);
        this.apply(result.store); this.messageType = 'success';
        this.message = send ? 'Settings saved and sent to auth server. Complete Clover authorization on the auth server.' : 'Clover settings saved.';
      } catch (e) { this.message = e.response ? 'Request failed. Please retry.' : e.message; this.messageType = 'danger'; }
      finally { this.busy = false; this.action = ''; }
    },
    tokenDate(value) { return value && /^\d+$/.test(String(value)) ? new Date(Number(value) * 1000).toLocaleString() : '—'; }
  }
};
</script>
<style scoped>
.clover-page{max-width:1100px;margin:auto;padding-bottom:40px}.clover-heading{display:flex;align-items:center;justify-content:space-between;gap:20px;margin-bottom:24px}.clover-heading h2{margin:0}.clover-actions{display:flex;gap:12px;justify-content:center;margin-top:28px}.clover-actions .el-button{margin-left:0}.clover-status{margin:28px 0 0;padding-top:18px;border-top:1px solid #e9ecef;display:grid;grid-template-columns:200px 1fr;gap:8px 20px;font-size:14px}.clover-status dd{margin:0;overflow-wrap:anywhere}@media(min-width:992px){.clover-page{padding-top:48px}}@media(max-width:600px){.clover-heading{align-items:flex-start;flex-direction:column;gap:6px}.clover-status{grid-template-columns:1fr;gap:2px}.clover-status dd{margin-bottom:12px}.clover-actions{flex-wrap:wrap}}
</style>
